import { annualPricesGermany, annualPrices, deductibleMultipliers, } from './priceData/pricing';
import { taxRatesLookup } from './models';
import { getAgeGroupFromDOB } from './utils/getAgeGroupFromDOB';
export var formatFloat = function (n) {
    return Number(n.toFixed(2));
};
export var getExpatLTPrices = function (_a) {
    var dateOfBirth = _a.dateOfBirth, region = _a.region, _b = _a.deductible, deductible = _b === void 0 ? '0' : _b, _c = _a.coveredArea, coveredArea = _c === void 0 ? 'AREA_ONE' : _c, _d = _a.isDependent, isDependent = _d === void 0 ? false : _d;
    var ageGroup = getAgeGroupFromDOB(dateOfBirth, isDependent);
    var priceLookup = region === 'de' ? annualPricesGermany : annualPrices;
    var _e = priceLookup[coveredArea][ageGroup], BASIC = _e.BASIC, PREMIUM = _e.PREMIUM;
    var multiplier = deductibleMultipliers[deductible];
    var basicMonthlyPrice = (BASIC / 12) * multiplier;
    var premiumMonthlyPrice = (PREMIUM / 12) * multiplier;
    var taxRate = taxRatesLookup[region];
    var taxAbsoluteBasic = basicMonthlyPrice * taxRate;
    var taxAbsolutePremium = premiumMonthlyPrice * taxRate;
    return {
        BASIC: formatFloat(basicMonthlyPrice + taxAbsoluteBasic),
        PREMIUM: formatFloat(premiumMonthlyPrice + taxAbsolutePremium),
    };
};
